type VerificationStatus = "verified" | "pending";

type BusinessField = {
  value: string;
  status: VerificationStatus;
};

export const business = {
  legalName: "IranTradeReach",
  tagline: "Iran-based sourcing and export development partner.",
  canonicalUrl: { value: "https://irantradereach.ir", status: "verified" } satisfies BusinessField,
  contact: {
    email: { value: "info@irantradereach.ir", status: "verified" },
    phone: { value: "+98 21 1234 5678", status: "pending" },
    address: { value: "Tehran, Iran", status: "pending" },
  } satisfies Record<string, BusinessField>,
  socialLinks: {
    linkedin: { value: "", status: "pending" },
    x: { value: "", status: "pending" },
    youtube: { value: "", status: "pending" },
  } satisfies Record<string, BusinessField>,
} as const;

export const venturePartner = {
  name: "Charehyar",
  url: "https://charehyar.ir",
  footerPrefix: "An international trade venture by",
  aboutText: "IranTradeReach is an international trade venture focused on helping Iranian manufacturers and suppliers connect with global markets. Built with the business development expertise of Charehyar, IranTradeReach combines market insight, strategic thinking, and practical execution to create new opportunities for international growth.",
  persianText: "IranTradeReach یکی از راهکارهای توسعه بازار و تجارت بین‌الملل چاره‌یار است.",
} as const;
